import React from 'react'

function FilterSvg() {
  return (
    <svg
    xmlns="http://www.w3.org/2000/svg"
    width={25}
    height={25}
    className="icon glyph"
    viewBox="0 0 24 24"
    fill="var(--dark-green)"
  >
    <path d="M12 9a3.66 3.66 0 0 0 1-.13V21a1 1 0 0 1-2 0V8.87A3.66 3.66 0 0 0 12 9ZM19 16a3.66 3.66 0 0 0 1-.13V21a1 1 0 0 1-2 0v-5.13a3.66 3.66 0 0 0 1 .13ZM20 3v5.13a3.91 3.91 0 0 0-2 0V3a1 1 0 0 1 2 0ZM6 3v12.13A3.66 3.66 0 0 0 5 15a3.66 3.66 0 0 0-1 .13V3a1 1 0 0 1 2 0ZM8 19a3 3 0 1 1-4-2.82 2.87 2.87 0 0 1 2 0A3 3 0 0 1 8 19ZM15 5a3 3 0 0 1-2 2.82 2.87 2.87 0 0 1-2 0A3 3 0 1 1 15 5ZM22 12a3 3 0 0 1-2 2.82 2.87 2.87 0 0 1-2 0 3 3 0 0 1 0-5.64 2.87 2.87 0 0 1 2 0A3 3 0 0 1 22 12Z" />
  </svg>
  )
}

export default FilterSvg
